<template>
  <div class="main">
    <div class="handle-search">
      <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="showDialog()">新增</el-button>
      <div class="search-box">
        <div class="searchItem">
          <span class="tit">状态：</span>
          <el-select style="width:120px" size="small" v-model="query.filterStatus" clearable  @change="getUserList">
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="停用"></el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span class="tit">用户名：</span>
          <el-input style="width:160px" size="small" v-model="query.searchText" placeholder="请输入用户名"></el-input>
        </div>
        <div class="searchItem">
          <el-button size="small" type="primary" icon="el-icon-search" @click="getUserList">搜索</el-button>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      class="table"
       ref="multipleTable"
      :height="tableHeight"
      @row-click="showDialog"
      :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column label="序号" width="100" align="center" type="index"></el-table-column>
      <el-table-column label="用户名" align="center">
         <template slot-scope="scope">
            <span @click.stop>{{scope.row.nickName}}</span>
         </template>
      </el-table-column>
      <el-table-column prop="accountName" label="登录名" align="center">
         <template slot-scope="scope">
            <span @click.stop>{{scope.row.accountName}}</span>
         </template>
      </el-table-column>
      <el-table-column label="角色" align="center">
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.roleInfos" :key="index">
            {{item.roleName}}
            <em v-if="scope.row.roleInfos.length-1!=index">/</em>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="绑定店铺" align="center">
        <template slot-scope="scope">
          <div>
            <p v-for="(item, index) in scope.row.shopInfos" :key="index">{{item.shopName}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="FB广告账号" align="center">
        <div slot-scope="scope">
          <p
            v-for="(item, index) in scope.row.advertisementAccounts"
            :key="index"
          >{{item.advertisementAccount}}</p>
        </div>
      </el-table-column>
      <el-table-column prop="a" label="状态" align="center" width="80"> 
        <template slot-scope="scope">
          <el-switch active-color="#ff4700" v-model="scope.row.curStatus==1?true:false" @change="updateState(scope.row)" @click.stop.native></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
    </el-table>
    <div class="pagination">
       <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="[ 20,50,100,200]"
        @size-change="sizeChange"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 新增 -->
    <el-dialog :title="dialogTitile" :visible.sync="dialogFormVisible" width="650px">
      <div class="content">
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="用户昵称:">
            <el-input style="width:60%" v-model="form.UserNickName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="登录名:">
            <el-input style="width:60%" v-model="form.UserName" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="密码:">
            <el-input
              type="password"
              style="width:60%"
              v-model="form.UserPassword"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="绑定角色:">
            <el-select v-model="form.RoleId" multiple placeholder="请选择角色" style="width:60%">
              <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺:">
            <el-select v-model="form.ShopId" multiple placeholder="请选择店铺" style="width:60%">
              <el-option
                v-for="item in shopList"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="FB广告账号:">
            <el-select
              v-model="form.AdvertisementAccountIds"
              multiple
              placeholder="请选择广告账号"
              style="width:60%"
            >
              <el-option
                v-for="item in advList"
                :key="item.id"
                :label="item.accountInfo"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="绑定店铺" :visible.sync="bindShop" width="600px">
      <div class="shopList">
        <el-checkbox
          v-model="item.isSelected"
          v-for="(item,index) in shopList"
          :key="index"
          @change="changeShopState(item)"
        >{{item.shopName}}</el-checkbox>
      </div>
    </el-dialog>
    <el-dialog title="绑定角色" :visible.sync="bindRole" width="600px">
      <div class="shopList">
        <el-checkbox
          v-model="item.isSelected"
          @change="changeRoleState(item)"
          v-for="(item,index) in roleList"
          :key="index"
        >{{item.roleName}}</el-checkbox>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetCurUserAllRoleList,
  AddUser,
  SetUserRoles,
  SetUser,
  GetOwnAdvertisementAccountShowInfo,
  GetAllUser,
  GetAllShopListOfShopify,
  GrantRoleToUser,
  AddShopUserRalation,
  RemoveShopUserRalation,
  GetAimUserShopList,
  UpdateUserStatus
} from "@/utils/api";
export default {
  data() {
    return {
      dialogFormVisible: false,
      bindShop: false,
      bindRole: false,
      dialogTitile: "新增用户",
      tableData: [],
      roleList: [],
      advList: [],
      shopList: [],
      tableHeight:0,
      pageTotal: 10,
      UserId: 0,
      query:{
        pageStart:1,
        limit:20,
        searchText:"",
        filterStatus:"1"
      },
      form: {
        userId: -1,
        UserName: null,
        UserNickName: null,
        ShopId: null,
        AdvertisementAccountIds: null,
        RoleId: null
      }
    };
  },
   mounted(){
    this.$nextTick(()=>{
      this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop -135;
    })
  },
  methods: {
    showDialog(item) {
      if (!item) {
        this.dialogTitile = "新增用户";
        this.form = {
          userId: -1
        };
      } else {
        let data = JSON.parse(JSON.stringify(item));
        let ShopIds = [],
          AdvertisementAccountIds = [],
          RoleIds = [];
        data.advertisementAccounts.forEach(v => {
          AdvertisementAccountIds.push(v.id);
        });
        data.roleInfos.forEach(v1 => {
          RoleIds.push(v1.roleId);
        });
        data.shopInfos.forEach(v2 => {
          ShopIds.push(v2.shopId);
        });

        this.dialogTitile = "修改用户";
        this.form.UserName = data.accountName;
        this.form.UserNickName = data.nickName;
        this.form.userId = data.userId;
        this.form.ShopId = ShopIds;
        this.form.AdvertisementAccountIds = AdvertisementAccountIds;
        this.form.RoleId = RoleIds;
      }
      this.dialogFormVisible = true;
    },
    updateState(item){
      UpdateUserStatus({
        UserId:item.userId,
        Status:item.curStatus==1?0:1
      }).then(res=>{
          this.$message.success('状态更新成功');
          this.getUserList();
      })
    },
    // 获取角色列表
    getRoleList() {
      GetCurUserAllRoleList().then(res => {
        if (res) {
          this.roleList = res;
          this.roleList = this.roleList.map((item, index) => {
            return { ...item, isSelected: false };
          });
        }
      });
    },
    // 获取店铺列表
    getShopList() {
      GetAllShopListOfShopify().then(res => {
        if (res) {
          this.shopList = res;
          this.shopList = this.shopList.map((item, index) => {
            return { ...item, isSelected: false };
          });
        }
      });
    },
    getOwnAdvertisementAccountShowInfo() {
      GetOwnAdvertisementAccountShowInfo().then(res => {
        this.advList = res;
      });
    },
    // 获取用户列表
    getUserList() {
      GetAllUser(this.query).then(res => {
        if (res) {
          this.tableData = res.data;
          this.pageTotal = res.totalData;
        }
      });
    },
    showShop(item) {
      this.bindShop = true;
      this.UserId = item.userId;
      this.shopList = this.shopList.map(item => {
        return {
          ...item,
          isSelected: false
        };
      });
      GetAimUserShopList({
        userId: item.userId
      }).then(res => {
        res.forEach((v, i) => {
          this.shopList.forEach((v1, i1) => {
            if (v1.shopId == v.shopId) {
              this.$set(this.shopList[i1], "isSelected", true);
            }
          });
        });
      });
    },
    showRole(item) {
      this.bindRole = true;
      this.UserId = item.userId;
      item.roleInfos.forEach((v, i) => {
        this.roleList.forEach((v1, i1) => {
          if (v1.roleId == v.roleId) {
            this.$set(this.roleList[i1], "isSelected", true);
          }
        });
      });
    },
    changeShopState(item) {
      if (!item.isSelected) {
        RemoveShopUserRalation({
          UserId: this.UserId,
          ShopId: item.shopId
        }).then(res => {
          this.$message.success("店铺解绑成功");
          this.getUserList();
        });
      } else {
        AddShopUserRalation({
          UserId: this.UserId,
          ShopId: item.shopId
        }).then(res => {
          this.$message.success("店铺绑定成功");
          this.getUserList();
        });
      }
    },
    changeRoleState(item) {
      let roleIds = [];
      let userId = this.UserId;
      this.roleList.forEach(v => {
        if (v.isSelected) {
          roleIds.push(v.roleId);
        }
      });
      SetUserRoles({
        roleIds,
        userId
      }).then(res => {
        if (res) {
          this.$message.success("角色设置成功");
          this.getUserList();
        }
      });
    },

    //提交
    submit() {
      let {
        UserName,
        UserNickName,
        UserPassword,
        userId,
        ShopId,
        AdvertisementAccountIds,
        RoleId
      } = this.form;

      if (!UserName) {
        this.$message.error("用户名不能为空");
        return;
      }

      if (!UserPassword && userId == -1) {
        this.$message.error("密码不能为空");
        return;
      }

      SetUser({
        UserName,
        UserNickName,
        UserPassword,
        userId,
        ShopIds:ShopId,
        AdvertisementAccountIds,
        RoleIds:RoleId
      }).then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.getUserList();
          this.dialogFormVisible = false;
        }
      });
    },
    // 改变分页
     // 改变分页
    handlePageChange(val) {
      this.query.pageStart = val;
      this.getAllAdvertisementList();
    },
    sizeChange(val) {
      this.query.limit = val;
      this.getAllAdvertisementList();
    }
  },
  components: {},
  created() {
    this.getUserList();
    this.getRoleList();
    this.getShopList();
    this.getOwnAdvertisementAccountShowInfo();
  }
};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  .handle-search {
    background: #f3f3f3;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    padding: 10px 20px;
    border-radius: 5px;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .search-box {
      display: flex;
      width: 80%;
      justify-content: flex-end;
      .searchItem {
        margin-left: 20px;
        input,
        select {
          width: 160px;
        }
      }
    }
  }
  .pagination {
    text-align: center;
    margin-top: 20px;
  }
  .handle-fun {
    margin: 20px 0;
  }
  .shopList {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding-left: 60px;
    /deep/ .el-checkbox {
      margin-top: 5px;
      margin-bottom: 5px;
      width: 220px;
    }
  }
}
/deep/ .el-table__row{
  cursor: pointer;
}
</style>